import { createPost } from "blog/post"
import { NodeKind } from "blog/json_nodes"

export const HowDoIPutGoLangProjectAnywhere = createPost({
  kind: NodeKind.POST,
  title: "How Do I Put My Golang Project Anywhere",
  date: "2020-06-30T:15:45:00.0000Z",
  tags: ["programming", "lessons"],
  content: `
    <p>
      The other day I decided to translate an old project to Golang.
      It was originally written in Python 2 and later partially re-written in JavaScript.
      Rather than continue writing it in JS, it seemed like a good opportunity to learn a useful language.
      Between Golang and Rust I got the impression I'd have the least nerdy discussions with Golang so that's the direction I leaned in.
    </p>
    <p>
      Previous go experiencing writing Hello World made me the perfect candidate to make the swap, but for one major issue.
      <br />
      <bold>Google.</bold>
      <br />
      <small>Here's a <a href="https://medium.com/@steve.yegge/dear-google-cloud-your-deprecation-policy-is-killing-you-ee7525dc05dc">rant from Steve Yegge</a> on the big G-Corp</small>
    </p>
    <p>
      No that wasn't really the problem. The problem was that in every language I can recall you put your files in a folder and run them
      Coming from JS land I was confused about where to put my files and run code.
      I wanted a small part of an existing project to be Golang and felt some pain/confusion getting it running.
      I had followed the Golang getting started but didn't want to just have a global <code>GOPATH</code> directory to put all my code in, I wanted my Golang code in a subdirectory of an existing project.
    </p>
    <ol>
      <p>This is how I got it to work:</p>
      <li>Choose a root directory.</li>
      <li>Make a directory (I called mine <code>src</code> to hold your <code>*.go</code> files in the root directory (I called my root directory "web")</li>
      <li>Run <code>go mod init {path to code directory}</code> in that directory (Again, the one I called "web")</li>
      <li>Make a directory in root called <code>vendor</code></li>
      <li>Run <code>go mod vendor</code> // you'll need to do this every time you want to move 3rd party packages to the vendor directory</li>
    </ol>
    <p>
      If someone has a better way of doing it please let me know because this method doesn't feel quite right.
    </p>
    `,
  relatedPosts: [],
  references: [],
  ads: [],
})
